import React from "react"
import { StrongT } from "./UIStyle/UIstyle"
import styled from "styled-components"
import NextImg from "@/common/components/NextImg/index"
import { theme } from "./mixin"
import Button from "./Button"

export default function PartnerCard({
  img,
  title,
  rewards,
  desc,
  buttonContent1,
  buttonLink1,
  buttonContent2,
  buttonLink2,
  right,
  id,
  id2
}) {
  return (
    <Wrapper id={id}>
      <BannerWrapper className={right ? "right" : ""}>
        <ImageWrapper>
          <NextImg src={img} />
        </ImageWrapper>
      </BannerWrapper>
      <ContentWrapper>
        <TitleWrapper>
          <h3>{title}</h3>
          <h4>{rewards}</h4>
          <StrongT>{desc}</StrongT>
          <ButtonsWrapper>
            {buttonContent1 && (
              <Button
                content={buttonContent1}
                arrow
                href={buttonLink1}
                id={id2}
                blank
              />
            )}
            {buttonContent2 && (
              <Button
                content={buttonContent2}
                href={buttonLink2}
                id={id}
                arrow
                secondary
                blank
              />
            )}
          </ButtonsWrapper>
        </TitleWrapper>
      </ContentWrapper>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  width: 100%;
  position: relative;
  border-radius: 40px;
  overflow: hidden;
  box-shadow: 1px 1px 24px rgba(0, 0, 0, 0.08);
  display: flex;
  background-color: #fff;
  box-sizing: border-box;
  @media (${theme.xxl}) {
    display: block;
  }
  @media (${theme.xxl}) {
    max-width: 500px;
    margin: 0 auto;
  }
  @media (${theme.md}) {
    border-radius: 20px;
  }
`

const BannerWrapper = styled.div`
  width: 100%;
  padding: 8px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  &.right {
    order: 2;
  }
`

const ImageWrapper = styled.div`
  border-radius: 32px;
  overflow: hidden;
  width: 100%;
  @media (${theme.lg}) {
  }
  @media (${theme.md}) {
    border-radius: 12px;
  }
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  padding: 0 60px;
  @media (${theme.xxl}) {
    padding: 0 30px;
    align-items: center;
  }
  @media (${theme.md}) {
    align-items: center;
  }
  h2 {
    font-family: ${theme.titleFonts};
    font-weight: 700;
    line-height: 1.2;
    color: ${({ color }) => (color ? color : theme.secondary)};
    font-size: 36px;
    margin: 0;
    @media (${theme.md}) {
      font-size: 54px;
    }
  }
  h3 {
    font-family: ${theme.titleFonts};
    font-weight: 700;
    line-height: 1.2;
    color: ${({ color }) => (color ? color : theme.secondary)};
    font-size: 36px;
    margin: 0;
    @media (${theme.md}) {
      font-size: 28px;
    }
  }
  h4 {
    font-family: ${theme.titleFonts};
    font-weight: 700;
    line-height: 1.2;
    background: ${theme.CTAcolorLinear};
    -webkit-background-clip: text;
    display: inline-block;
    -webkit-text-fill-color: transparent;
    font-size: 24px;
    margin: 0;
    @media (${theme.md}) {
      font-size: 20px;
    }
  }
`
const ContentWrapper = styled.div`
  padding: 60px 0px;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  flex: 1;
  order: 1;
  @media (${theme.xxl}) {
    padding: 20px 0px 60px;
  }
  @media (${theme.md}) {
    padding: 0px 0px 40px;
  }
`

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  position: relative;
  flex-wrap: wrap;
  @media (${theme.xxl}) {
    max-width: 300px;
    width: 100%;
    gap: 12px;
    a {
      width: 100%;
      div {
        width: 100%;
        max-width: 100%;
      }
    }
  }
  @media (${theme.lg}) {
    flex-wrap: nowrap;
    gap: 12px;
  }
  @media (${theme.md}) {
    flex-wrap: wrap;
    max-width: 300px;
    width: 100%;
    gap: 12px;
    a {
      div {
        width: 100%;
        max-width: 100%;
      }
    }
  }
`

const A = styled.div``
